import Vue from 'vue';

const state = {
	performanceReviews: [],
	performanceReviews_loading: false
};

const getters = {
	performanceReviews: state => {
		return state.performanceReviews;
	},
	performanceReviewsPendingList: (state, getters, rootState, rootGetters) => {
		var filtered = state.performanceReviews
			.filter(p => p.status !== 'Complete')
			.sort(function(a, b) {
				return new Date(a.scheduledDateUTC) - new Date(b.scheduledDateUTC);
			});

		return filtered.map(performanceReview => {
			let model = {
				id: performanceReview.id,
				employee: performanceReview.employee.fullName,
				employeeId: performanceReview.employee.id,
				reviewer: performanceReview.reviewer.fullName,
				reviewerId: performanceReview.reviewer.id,
				scheduledDate: performanceReview.scheduledDateUTC,
				positionTitle: performanceReview.position != null ? performanceReview.position.title : performanceReview.positionTitle,
				isLoggedInEmployee: performanceReview.employee.id === rootGetters['loggedInEmployee'].id,
				isLoggedInReviewer: performanceReview.reviewer.id === rootGetters['loggedInEmployee'].id,
				name: performanceReview.name,
				status: performanceReview.status
			};
			return model;
		});
	},
	performanceReviewsCompletedList: (state, getters, rootState, rootGetters) => {
		var filtered = state.performanceReviews
			.filter(p => p.status === 'Complete')
			.sort(function(a, b) {
				return new Date(a.scheduledDateUTC) - new Date(b.scheduledDateUTC);
			});

		return filtered.map(performanceReview => {
			let model = {
				id: performanceReview.id,
				employee: performanceReview.employee.fullName,
				employeeId: performanceReview.employee.id,
				reviewer: performanceReview.reviewer.fullName,
				reviewerId: performanceReview.reviewer.id,
				scheduledDate: performanceReview.scheduledDateUTC,
				positionTitle: performanceReview.position != null ? performanceReview.position.title : performanceReview.positionTitle,
				isLoggedInEmployee: performanceReview.employee.id === rootGetters['loggedInEmployee'].id,
				isLoggedInReviewer: performanceReview.reviewer.id === rootGetters['loggedInEmployee'].id,
				name: performanceReview.name,
				status: performanceReview.status,
				completedDateUtc: performanceReview.completedDateUtc
			};
			return model;
		});
	},
	performanceReviewsMyList: (state, getters, rootState, rootGetters) => {
		var filtered = state.performanceReviews
			.filter(p => p.status !== 'Complete' && (p.employee.id === rootGetters['loggedInEmployee'].id || p.reviewer.id === rootGetters['loggedInEmployee'].id))
			.sort(function(a, b) {
				return new Date(a.scheduledDateUTC) - new Date(b.scheduledDateUTC);
			});

		return filtered.map(performanceReview => {
			let model = {
				id: performanceReview.id,
				employee: performanceReview.employee.fullName,
				employeeId: performanceReview.employee.id,
				reviewer: performanceReview.reviewer.fullName,
				reviewerId: performanceReview.reviewer.id,
				scheduledDate: performanceReview.scheduledDateUTC,
				positionTitle: performanceReview.position != null ? performanceReview.position.title : performanceReview.positionTitle,
				isLoggedInEmployee: performanceReview.employee.id === rootGetters['loggedInEmployee'].id,
				isLoggedInReviewer: performanceReview.reviewer.id === rootGetters['loggedInEmployee'].id,
				name: performanceReview.name,
				status: performanceReview.status
			};
			return model;
		});
	},
	performanceReviewsPendingCount: state => {
		var filtered = state.performanceReviews.filter(p => p.status !== 'Complete');

		return filtered.length;
	}
};

const actions = {
	get({ commit, rootState }) {
		console.log('Retrieving Performance Reviews...');
		commit('GET_PENDING');
		return Vue.axios
			.get(`/api/${rootState.tenantId}/performancereviews/list`)
			.then(response => {
				commit('GET_SUCCESS', response.data);
			})
			.catch(error => {
				commit('GET_FAILURE', error);
			});
	},
	getById({ rootState }, id) {
		return new Promise((resolve, reject) => {
			Vue.axios
			.get(`/api/${rootState.tenantId}/performanceReviews/${id}`)
			.then(response => {
				resolve(response.data);
			})
			.catch(error => {
				reject(error);
			});
		});		
	},
	add({ commit, dispatch, rootState }, performanceReview) {
		console.log('Adding New Performance Review...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.post(`/api/${rootState.tenantId}/performancereviews`, performanceReview)
				.then(resp => {
					commit('ADD_SUCCESS', resp.data);
					resolve(resp.data);
				})
				.catch(err => {
					console.log('Error saving Performance Review');
					console.log(err);
					reject(err);
				});
		});
	},
	edit({ commit, dispatch, rootState }, performanceReview) {
		console.log('Updating Performance Review...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.put(`/api/${rootState.tenantId}/performancereviews/${performanceReview.id}`, performanceReview)
				.then(resp => {
					commit('EDIT_SUCCESS', resp.data);
					resolve(resp.data);
				})
				.catch(err => {
					console.log('Error updating Performance Review');
					console.log(err);
					reject(err);
				});
		});
	},
	delete({ commit, dispatch, rootState }, performanceReview) {
		console.log('Deleting Performance Review...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.delete(`/api/${rootState.tenantId}/performancereviews/${performanceReview.id}`)
				.then(resp => {
					commit('DELETE_SUCCESS', performanceReview.id);
					resolve(resp);
				})
				.catch(err => {
					console.log('Error deleting performance review...');
					console.log(err);
					reject(err);
				});
		});
	},
	postSubmit({ commit, dispatch, rootState }, submitObj) {
		console.log('Submitting Performance Review...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.put(`/api/${rootState.tenantId}/performancereviewsubmits/${submitObj.performanceReviewId}`, submitObj)
				.then(resp => {
					commit('SUBMIT_SUCCESS', resp.data);
					resolve(resp);
				})
				.catch(err => {
					console.log('Error submitting Performance Review');
					console.log(err);
					reject(err);
				});
		});
	},
	updateSubmitItem({ commit, rootState }, payload) {
		console.log('Updating Performance Review...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.put(`/api/${rootState.tenantId}/PerformanceReviews/${payload.performanceReviewId}/Submit/${payload.submitId}/Items/${payload.id}`, payload)
				.then(resp => {
					commit('UPDATE_SUBMIT_ITEM_SUCCESS', resp.data);
					resolve(resp.data);
				})
				.catch(err => {
					console.log('Error updated Performance Review Submit Item');
					console.log(err);
					reject(err);
				});
		});
	},
	postDiscussion({ commit, rootState }, submitObj) {
		console.log('Submitting Performance Review Discussion...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.put(`/api/${rootState.tenantId}/performanceReviewDiscussions/${submitObj.performanceReviewId}`, submitObj)
				.then(resp => {
					commit('SUBMIT_DISCUSSION_SUCCESS', resp.data);
					resolve(resp);
				})
				.catch(err => {
					console.log('Error submitting Performance Review Discussion');
					console.log(err);
					reject(err);
				});
		});
	},
	uploadDocument({ dispatch, rootState }, data) {
		console.log('Uploading Document...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.post(`/api/${rootState.tenantId}/performancereviews/${data.performanceReviewId}/files`, data.document, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				})
				.then(resp => {
					dispatch('get');
					resolve(resp);
				})
				.catch(err => {
					console.log('Error uploading document...');
					console.log(err);
					reject(err);
				});
		});
	},
	deleteDocument({ dispatch, rootState }, data) {
		console.log('Deleting Document...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.delete(`/api/${rootState.tenantId}/performancereviews/${data.performanceReviewId}/files/${data.id}`)
				.then(resp => {
					dispatch('get');
					resolve(resp);
				})
				.catch(err => {
					console.log('Error deleting document...');
					console.log(err);
					reject(err);
				});
		});
	},
	downloadDocument({ dispatch, rootState }, data) {
		Vue.axios({
			url: `/api/${rootState.tenantId}/performanceReviews/${data.performanceReviewId}/Files/${data.id}`,
			method: 'GET',
			responseType: 'blob'
		}).then(response => {
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', data.fileName);
			document.body.appendChild(link);
			link.click();
		});
	},
	updateSchedule({ commit, dispatch, rootState }, submitObj) {
		console.log('Updating Performance Review Schedule...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.put(`/api/${rootState.tenantId}/performanceReviewSchedule/${submitObj.id}`, submitObj)
				.then(resp => {
					commit('UPDATE_SCHEDULE_SUCCESS', resp.data);
					resolve(resp);
				})
				.catch(err => {
					console.log('Error updating Performance Review Schedule');
					console.log(err);
					reject(err);
				});
		});
	}
};

const mutations = {
	GET_PENDING(state) {
		state.performanceReviews_loading = true;
	},
	GET_SUCCESS(state, data) {
		state.performanceReviews_loading = false;
		state.performanceReviews = data;
	},
	GET_FAILURE(state, error) {
		state.performanceReviews_loading = false;
		console.log(error);
	},
	ADD_SUCCESS(state, data) {
		state.performanceReviews.push(data);
	},
	EDIT_SUCCESS(state, data) {
		let foundIndex = state.performanceReviews.findIndex(pr => pr.id === data.id);
		if (foundIndex > -1) {
			state.performanceReviews.splice(foundIndex, 1, data);
		}
	},
	DELETE_SUCCESS(state, id) {
		const index = state.performanceReviews.findIndex(pr => pr.id === id);
		state.performanceReviews.splice(index, 1);
	},
	SUBMIT_SUCCESS(state, data) {
		let foundIndex = state.performanceReviews.findIndex(pr => pr.id === data.id);
		if (foundIndex > -1) {
			state.performanceReviews.splice(foundIndex, 1, data);
		}	
	},
	SUBMIT_DISCUSSION_SUCCESS(state, data) {
		let foundIndex = state.performanceReviews.findIndex(pr => pr.id === data.id);
		if (foundIndex > -1) {
			state.performanceReviews.splice(foundIndex, 1, data);
		}
	},
	UPDATE_SCHEDULE_SUCCESS(state, data) {
		let foundIndex = state.performanceReviews.findIndex(pr => pr.id === data.id);
		if (foundIndex > -1) {
			state.performanceReviews.splice(foundIndex, 1, data);
		}
	},
	UPDATE_SUBMIT_ITEM_SUCCESS(state, data) {
		let foundIndex = state.performanceReviews.findIndex(pr => pr.id === data.id);
		if (foundIndex > -1) {
			state.performanceReviews.splice(foundIndex, 1, data);
		}
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
